@if (!!product?.data?.long_description) {
<div class="m-t-9 m-t-4-s m-t-4-m p-l p-r p-l-0-s p-r-0-s p-l-0-m p-r-0-m">

    <h3 sizeClass="!SM:h3, SM:h4">{{'Product Description' | translate }}</h3>
    @if (!showLongDescription && (app.client.sizeId < 2))
      {
      <div
      class="p2 m-t-2 description"
      [innerHTML]="product?.data?.short_description || product?.data?.long_description">
</div>
@if (product?.data?.short_description && product?.data?.long_description){
<button (click)="toggle()"
        class="p2 m-t-2 col-11 b-col-11 b-b">{{'Read More' | translate }}</button>
}
}

@if (showLongDescription || app.client.sizeId > 1) {

<div class="p2 m-t-2 description"
     [innerHTML]="product?.data?.long_description">
</div>
}

@if (hasDimensionsSections()) {
<button type="button"
        [dialogOpen]="'dimensionsAndDetailsModalRight'">
    <span class="p1 b-b b-col-1">{{'View dimensions & details' | translate}}</span>
</button>
}
</div>
}